import {
  useCenterMap,
  UseCenterMapProps,
} from 'features/mapping/hooks/useCenterMap';

export const CenterMap = (props: UseCenterMapProps): null => {
  useCenterMap(props);
  return null;
};
